import { setPermissions } from './utils'

export const setTableCellData = ({ agentPermissions, isAgentOwnership, isAgentOffice, permissionToken }) => {
    const hasPermission = Boolean(setPermissions(agentPermissions, permissionToken, isAgentOwnership, isAgentOffice))
    
    return { hasPermission }
}
